const actions = {
  GET_DATA_PRODUCT: 'GET_DATA_PRODUCT',
  SET_DATA_PRODUCT: 'SET_DATA_PRODUCT',
  EDIT_DATA_PRODUCT: 'EDIT_DATA_PRODUCT',
  DELETE_DATA_PRODUCT: 'DELETE_DATA_PRODUCT',
  GET_DATA_FINISH: 'GET_DATA_FINISH',
  GET_DATA_BEGIN: 'GET_DATA_BEGIN',
  //NEW
  SET_NEW_DATA_PRODUCT: 'SET_NEW_DATA_PRODUCT',
  FILTER_BY_PROVIDER: 'FILTER_BY_PROVIDER',

  getProductData: () => {
    return {
      type: actions.GET_DATA_PRODUCT,
    };
  },
  setProductData: (data: any) => {
    return {
      type: actions.SET_DATA_PRODUCT,
      data,
    };
  },
  getDataBegin: () => {
    return {
      type: actions.GET_DATA_BEGIN,
    };
  },
  getDataFinish: () => {
    return {
      type: actions.GET_DATA_FINISH,
    };
  },
  setDeleteProduct: (data: any) => {
    return {
      type: actions.DELETE_DATA_PRODUCT,
      data,
    };
  },
  setEditProductData: (data: any) => {
    return {
      type: actions.EDIT_DATA_PRODUCT,
      data,
    };
  },
  setNewProductData: (data: any) => {
    return {
      type: actions.SET_NEW_DATA_PRODUCT,
      data,
    };
  },
};


export default actions;
